<template>
  <div>
    <h2 class="m-boxInfo__title">Next steps:</h2>
    <div class="m-boxInfo--container">
      <ol class="m-boxInfo--steps">
        <li class="m-boxInfo--steps__step" v-for="(step, index) in steps" v-bind:key="index">
          <span class="m-boxInfo--steps__step__text" v-html="step.message"></span>
        </li>
      </ol>
      <p class="m-boxInfo__myAccount">
        You can manage your products, view billing history, 
        update payment methods and manage devices in
        <a
          href="https://account.serato.com/#/"
          class="a-Link--Blue"
        >
          My Account.
        </a>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      steps: {
        type: Array,
        default: () => []
      }
    }
  }
</script>





// WEBPACK FOOTER //
// BoxInfo.vue?e65ada0a